/* back.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 17 16" preserveAspectRatio="none">
            <polygon class="foreground-gl" points="16.3,16 8.2,7.5 16.3,0 17,0.7 9.6,7.6 17,15.4 "/>
            <polygon class="foreground-gl" points="7,15 0,7.5 7.1,1 7.8,1.6 1.4,7.6 7.8,14.4 "/>
            </svg>
         `
};
